import { VueApp } from 'larasnap';
import App from './HistoryViewer.vue';

export default class extends VueApp {
    static registerAs = 'HistoryViewer';

    constructor(element) {
        super(element, App);
    }
}
